import React from 'react';
import PropTypes from 'prop-types';

import { PartnerSelectionChoices } from '../../utils/constants';
import Img from '../Img';
import EventPlayerSearch from '../Form/EventPlayerSearch';

import styles from './eventRegForm.scss';

const FindPlayerFromNeedPartner = props => {
    const { teammate, needsPartnerPlayers, user, selectedDivision, utrTypeId, sportTypeId } = props;

    const isAddNeedsPartnerSelected = props.step.invite === PartnerSelectionChoices.ADD_NEEDS_PARTNER;

    return (
        <div className={`radio-button noselect`}>
            <input
                type="radio"
                id={PartnerSelectionChoices.ADD_NEEDS_PARTNER}
                name="teammate"
                value={PartnerSelectionChoices.ADD_NEEDS_PARTNER}
                checked={teammate === PartnerSelectionChoices.ADD_NEEDS_PARTNER}
                onChange={props.addTeammate}
            />
            <label htmlFor={PartnerSelectionChoices.ADD_NEEDS_PARTNER} className="flex-wrap">
                <div className="radio-button-check"><Img src="/img/icons/checkmark-icon.svg" /></div>
                <div className="radio-button-label flex-1 mw0" style={{ margin: '24px 0' }}>
                    <div>Select Registered Player from Need Partner List</div>
                    <div className="mt8">
                        <div className={`${styles.partnerEmailDescription} text-small mb16`}>
                            {`Select an eligible player who is registered and already on a Need Partner list for this event.`}
                        </div>
                    </div>
                    {isAddNeedsPartnerSelected && (
                        <EventPlayerSearch
                            players={needsPartnerPlayers}
                            user={user}
                            handlePlayerSelect={props.selectTeammate}
                            divisionFormatTypeId={selectedDivision?.divisionFormatTypeId}
                            utrTypeId={utrTypeId}
                            sportTypeId={sportTypeId}
                        />
                    )}
                    {isAddNeedsPartnerSelected && (
                        <button
                            type="button"
                            className={`btn btn-primary btn-block text-uppercase`}
                            onClick={props.addTeammateToDivision}
                            disabled={!props.step.selectedPlayer || (props.step.selectedPlayer.profileId <= 0 && !props.step.selectedPlayer.email)}
                        >
                            Add Partner
                        </button>
                    )}
                </div>
            </label>
        </div>
    );
};

FindPlayerFromNeedPartner.propTypes = {
    selectTeammate: PropTypes.func.isRequired,
    selectedDivision: PropTypes.objectOf(PropTypes.any).isRequired,
    utrTypeId: PropTypes.number.isRequired,
    sportTypeId: PropTypes.number.isRequired,
    teammate: PropTypes.string.isRequired,
    needsPartnerPlayers: PropTypes.arrayOf(PropTypes.any).isRequired,
    user: PropTypes.objectOf(PropTypes.any).isRequired,
    addTeammate: PropTypes.func.isRequired,
    addTeammateToDivision: PropTypes.func.isRequired,
    step: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default FindPlayerFromNeedPartner;
